// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__11wLR","rootCenter":"LoadMoreObserver_rootCenter__1xNCj","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3RC0v"};